import React from 'react';
import './LoadingOverlay.css';

function LoadingOverlay({ visible }) {
  if (!visible) return null;
  return (
    <div className="loading-overlay" role="status" aria-live="polite" aria-label="Loading">
      <div className="loading-overlay-spinner" />
      <p className="loading-overlay-text">Loading…</p>
    </div>
  );
}

export default LoadingOverlay;
